module.exports = __webpack_public_path__ + "img/15.0b29549f.jpg";